import { anyOf, arrayOf, is, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetAppSettingsAppGroupIdApiKeysApiKeyIdMetadataResult = anyOf(
  objectOf({
    id: string,
    name: string,
    key_type: anyOf(is("client"), is("server")),
    permissions: arrayOf(string),
    ip_allowlist: arrayOf(string),
    braze_to_braze_ip_allowlisting_enabled: boolean,
    created_at: number,
    impersonation_only: maybe(boolean),
  }),
  objectOf({ error: string })
);
